export default [
  {
    path: '/auth',
    component: () => import('@/pages/auth/Auth'),
    children: [
      {
        name: 'loginPage',
        path: '/auth/login',
        meta: { title: 'page.login' },
        component: () => import('@/pages/auth/Login'),
      },
      {
        name: 'restorePage',
        path: '/auth/restore',
        meta: { title: 'page.restore' },
        component: () => import('@/pages/auth/Restore'),
      },
      {
        name: 'recoveryPassword',
        path: '/auth/recovery-password/:token',
        meta: { title: 'page.recoveryPassword' },
        component: () => import('@/pages/auth/RecoveryPassword'),
      },
      {
        name: 'createPassword',
        path: '/auth/create-password/:token',
        meta: { title: 'page.recoveryPassword' },
        component: () => import('@/pages/auth/CreatePassword'),
      },
      {
        name: 'qrCodePage',
        path: '/auth/qr-code',
        meta: { title: 'page.qrCode' },
        component: () => import('@/pages/auth/QrCode'),
      },
      {
        name: 'expiredToken',
        path: '/auth/expired-token',
        meta: { title: 'page.expiredToken' },
        component: () => import('@/components/auth/AuthTokenExpired'),
      },
    ],
  },
]
